import { CollectionUtils } from "@rsm-hcd/javascript-core";
import { SelectOption } from "atoms/forms/select";
import { t } from "i18next";
import GroupWithExpirationRecord from "models/view-models/group-with-expiration-record";
import SelectFormField from "molecules/form-fields/select-form-field";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DateUtils from "utilities/date-utils";
import GroupEligibleGroupService from "utilities/services/groups/group-eligible-groups-service";
import { ToastManager } from "utilities/toast/toast-manager";

interface SuggestedTeamDropdownProps {
    ownerId: number;
    onChangeTeam: (selectedTeamId: number | undefined) => void;
}

const SuggestedTeamDropdown = (props: SuggestedTeamDropdownProps) => {
    const { ownerId, onChangeTeam } = props;
    const [teams, setTeams] = useState<GroupWithExpirationRecord[]>([]);
    const [value, setValue] = useState("");
    useEffect(() => {
        const listEligibleGroupsApi = async () => {
            try {
                const { resultObjects } =
                    await GroupEligibleGroupService.userList({ id: ownerId });
                if (CollectionUtils.isEmpty(resultObjects)) {
                    setTeams([]);
                    return;
                }
                setTeams(resultObjects);
            } catch (error) {
                ToastManager.error(t("getTeamsError"));
            }
        };

        listEligibleGroupsApi();
    }, [ownerId]);
    const suggestedTeamOptions = [
        {
            data: undefined,
            value: "",
            label: "Select a team",
            isPlaceholder: true,
        },
        ...createSelectOptions(teams!),
    ];

    const handleSuggestedTeamSelection = (
        newTeam: SelectOption<GroupWithExpirationRecord, string> | undefined
    ) => {
        setValue(newTeam?.value ?? "");
        onChangeTeam(newTeam?.data?.id);
    };

    return (
        <div>
            <SelectFormField
                label="Previously owned teams"
                onChange={handleSuggestedTeamSelection}
                options={suggestedTeamOptions}
                value={value}
            />
        </div>
    );
};

export default SuggestedTeamDropdown;

const createSelectOptions = (
    teams: GroupWithExpirationRecord[]
): Array<SelectOption<GroupWithExpirationRecord, string>> =>
    teams
        .map((team) => ({
            data: team,
            label: `${team.name!} ${moment().isAfter(team?.subscriptionExpiresOn) ? `(Expired ${DateUtils.formatIsoDate(team?.subscriptionExpiresOn?.toString())})` : ""}`,
            value: team.id?.toString()!,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
